// Content for the ISIC Smart Campus page (/smart)

export const DESPRE_POINTS = [
  {
    icon: "LayoutGrid",
    text: "Posibilitatea integrării cu catalogul electronic al instituției.",
  },
  {
    icon: "Mail",
    text: "Rapoarte automate privind prezența la orele de curs, trimise pe email către diriginții și/sau directorii instituției.",
  },
  {
    icon: "BellRing",
    text: "Posibilitatea de informare automată a părintelui, prin email, cu privire la prezența copilului la orele de curs.",
  },
  {
    icon: "Users",
    text: "Evidența în timp real a numărului de elevi aflați în campus.",
  },
];

export const SCHOOLS = [
  "Colegiul Național Onisifor Ghibu (Oradea)",
  "Colegiul Economic „Virgil Madgearu” (Ploiești)",
  "Școala Gimnazială Theodor Aman",
  "Colegiul Economic „Dimitrie Cantemir” (Suceava)",
  "Liceul Tehnologic „Vasile Sav” (Roman)",
  "Școala Atlas",
];

export const FLOW_STEPS = [
  "Elevul intră sau iese din instituție",
  "Legitimația este utilizată la punctul de acces",
  "Evenimentul de intrare sau ieșire este înregistrat în sistem",
];

export const TRACKING_LIST = [
  "Sistemul înregistrează exclusiv momentul intrării și ieșirii elevului din instituție.",
  "Datele pot fi vizualizate doar de personalul autorizat și desemnat de unitatea de învățământ.",
  "Sistemul nu permite urmărirea elevului în afara perimetrului școlii.",
  "Nu afișează poziția elevului.",
  "Nu colectează informații despre activitatea elevului în afara evenimentelor de intrare și ieșire.",
  "Oferă doar o evidență a prezenței în incinta instituției, fără funcții de localizare sau monitorizare.",
];

export const INSTITUTION_ADVANTAGES = [
  "Sistemul de monitorizare / control acces, care include cititoare de card, centrală de control, modul de comunicare și, în anumite situații, electromagnet.",
  "Instalarea sistemului.",
  "Mentenanță gratuită (nu include situații de vandalism sau deteriorări intenționate).",
];

export const PARENT_ADVANTAGES = [
  "Vizibilitate clară asupra prezenței copilului în instituție, prin evidența exactă a momentelor de intrare și ieșire.",
  "Posibilitatea notificării automate (în funcție de configurația stabilită de școală) în situația în care copilul nu ajunge la cursuri în intervalul orar stabilit.",
  "Creșterea nivelului de siguranță al copiilor prin limitarea accesului persoanelor neautorizate în incinta instituției.",
  "Certitudinea că instituția dispune de o evidență actualizată a elevilor aflați în campus, informație utilă în situații neprevăzute sau de urgență.",
];

export const OPTIONS = [
  {
    badge: "Opțiunea non-bancară",
    title: "Legitimația de acces",
    price: "70 RON",
    priceNote: "cotizație",
    featured: false,
    items: [
      "Legitimație emisă pe suport plastic, ce poate fi utilizată strict în campusul instituției de învățământ pentru accesarea sistemului ISIC Smart Campus.",
      "Nu este o legitimație ISIC și, pe cale de consecință, nu oferă recunoaștere globală a statutului de elev și nu oferă acces la rețeaua de reduceri și beneficii pentru elevi și studenți.",
      "Aplicarea și plata cotizației de 70 RON se fac pe un link special, pus la dispoziția celor care aleg această opțiune odată cu implementarea proiectului.",
    ],
  },
  {
    badge: "Recomandat",
    title: "Pachetul BRD-ISIC",
    price: "100% gratuit",
    priceNote: "pentru elev",
    featured: true,
    items: [
      "Include atât cardul de debit BRD-ISIC, cât și legitimația de acces în instituția de învățământ.",
      "Fiind un card ISIC, oferă acces la întreaga rețea de reduceri și beneficii ISIC, atât la nivel național, cât și internațional.",
      "Posesorii de BRD-ISIC pot face economii de peste 8.000 lei în fiecare an școlar.",
    ],
  },
];

export const ISIC_ARGS = [
  {
    title: "Peste 70 de ani de existență",
    text: "Programul ISIC a luat naștere în anul 1953, iar din anul 1968 a devenit un program UNESCO.",
  },
  {
    title: "Dovadă a statutului de elev sau student la nivel global",
    text: "ISIC este singura legitimație de elev sau student recunoscută la nivel global, emisă și acceptată în peste 130 de țări.",
  },
  {
    title: "Acces la o rețea exclusivă de reduceri și beneficii",
    text: "Elevii pot economisi sume importante în fiecare an școlar, folosind legitimația ISIC în țară și atunci când călătoresc în străinătate. Economiile anuale pot depăși 8.000 lei.",
  },
];

export const ISIC_STATS = [
  { value: "70+", label: "ani de existență" },
  { value: "130+", label: "țări unde este recunoscut" },
  { value: "8.000 lei", label: "economii posibile pe an" },
];

export const TIMELINE = [
  { year: "1953", label: "Nașterea programului ISIC" },
  { year: "1968", label: "Devine program UNESCO" },
  { year: "Astăzi", label: "Peste 130 de țări" },
];

export const NATIONAL_BENEFITS = [
  { name: "Penny", logo: "/assets/ro/logo-penny.webp", offer: "10% reducere" },
  { name: "IKEA", logo: "/assets/ro/logo-ikea.png", offer: "10% reducere la cardurile cadou" },
  { name: "Spotify", logo: "/assets/ro/logo-spotify.webp", offer: "Ofertă specială pentru studenți" },
  { name: "Christian Tour", logo: "/assets/ro/logo-christian-tour.png", offer: "Travel Prime gratuit, în loc de 79€ pe an" },
  { name: "Carrefour", logo: "/assets/ro/logo-carrefour.webp", offer: "7% reducere" },
  { name: "Burger King", logo: "/assets/ro/logo-burger-king.png", offer: "15% reducere" },
  { name: "Sephora", logo: "/assets/ro/logo-sephora.webp", offer: "20% reducere la Sephora Collection" },
  { name: "World Class", logo: "/assets/ro/logo-worldclass.png", offer: "Până la 40€ reducere la abonamente" },
];

export const GLOBAL_BENEFITS = [
  { alt: "Berlin - The Wall Museum - 6 euro reducere", image: "/assets/intl/intl-wall.png" },
  { alt: "Paris - Disneyland - până la 39 euro reducere", image: "/assets/intl/intl-disneyland.png" },
  { alt: "Roma - Muzeele Vaticane - 9 euro reducere", image: "/assets/intl/intl-vatican.png" },
  { alt: "Madrid - Muzeul Prado - 14 euro reducere", image: "/assets/intl/intl-prado.png" },
  { alt: "Paris - Arcul de Triumf - 3 euro reducere", image: "/assets/intl/intl-paris.png" },
];

export const SMART_LINKS = {
  nationalMore: "https://www.isic.ro/reduceri/local/?dmLimit=10&dmSortKey=views&dmSortOrder=desc&dmSeed=3100&dmDisplay=images",
  globalMore: "https://www.isic.org/discounts/",
};
